module.exports = __webpack_public_path__ + "uz.f32eacef.svg";